import {Directive, ElementRef, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { Gesture }  from 'ionic-angular';
declare var Hammer: any;

const ALLOWED_DIRECTIONS = ['up', 'down', 'left', 'right'];

@Directive({
  selector: '[swipe-to-close]'
})
export class SwipeToClose implements OnInit, OnDestroy {
  @Output('swipe-to-close') onClose: EventEmitter<any> = new EventEmitter();
  @Input('direction') direction: string = 'down';

  private handleElement: HTMLElement;
  private viewContainer: HTMLElement;
  private swipeLength: number;
  private swipeGesture: Gesture;
  private verticalSwipe: boolean;
  private positiveSwipe: boolean;
  private threshold: number = 0.1;

  constructor(element: ElementRef) {
    this.handleElement = element.nativeElement;
  }

  public ngOnInit() {
    this.viewContainer = this.handleElement;
    while (this.viewContainer = this.viewContainer.parentElement) {
      if (this.viewContainer.classList.contains('ion-page')) break;
    }
    if (!this.viewContainer) return console.error('Cannot find parent page');

    this.direction = this.direction || 'down';
    if (ALLOWED_DIRECTIONS.indexOf(this.direction) < 0) return console.error('Invalid direction');
    this.verticalSwipe = (['up', 'down'].indexOf(this.direction) >= 0);
    this.positiveSwipe = this.verticalSwipe ?
      (this.direction == 'down') :
      (this.direction == 'right');

    this.swipeLength = this.viewContainer.getBoundingClientRect()[this.verticalSwipe ? 'height' : 'width'];

    this.swipeGesture = new Gesture(this.handleElement, {
      recognizers: [
        [Hammer.Pan, {direction: this.verticalSwipe ? Hammer.DIRECTION_VERTICAL : Hammer.DIRECTION_HORIZONTAL}]
      ]
    });
    this.swipeGesture.listen();
    // this.swipeGesture.on('panstart', e => this.onSwipeStart(e));
    this.swipeGesture.on('panmove', e => this.onSwipe(e));
    this.swipeGesture.on('panend', e => this.onSwipeEnd(e));
  }
  public ngOnDestroy() {
    // this.swipeGesture.destroy()
  }
  public onSwipe($event) {
    let moved: number = this.movedDistance($event),
      percent: number = (this.swipeLength - moved) / this.swipeLength;

    if (this.verticalSwipe) {
      this.viewContainer.style.top = (this.positiveSwipe ? moved : -moved) + 'px';
      this.viewContainer.style.transformOrigin = this.positiveSwipe ? 'top center' : 'bottom center';
    } else {
      this.viewContainer.style.left = (this.positiveSwipe ? moved : -moved) + 'px';
      this.viewContainer.style.transformOrigin = this.positiveSwipe ? 'middle left' : 'middle right';
    }
    this.viewContainer.style.opacity = percent.toString();
    // this.viewContainer.style.transform = `scale(${Math.max(percent, 0.5)})`;
    this.viewContainer.style.transition = 'none';
  }
  public onSwipeEnd($event) {
    let moved: number = this.movedDistance($event),
      percent: number = (this.swipeLength - moved) / this.swipeLength;

    if (percent < 1 - this.threshold) {
      this.onClose.emit($event);
      // this.viewController.dismiss();
    } else {
      this.viewContainer.style.transition = '';
      this.viewContainer.style.opacity = '1';
      this.viewContainer.style.top = '0';
      // this.viewContainer.style.transform = '';
    }
  }
  private movedDistance($event): number {
    return Math.max((this.verticalSwipe ? $event.deltaY : $event.deltaX) * (this.positiveSwipe ? 1 : -1), 0);
  }
}



// WEBPACK FOOTER //
// ./src/directives/swipe-to-close.directive.ts